import ImageBanner from '@components/ImageBanner'
import type { pageTitle, pageContent } from '@lib/types'
import { getPageTitleContentFromDB, getPageContentFromDB } from '@lib/pagequerys'
import type { GetStaticProps } from 'next'
import ImageGallery from '@components/ImageGallery'
import { Container, Heading, Section, Text } from '@components/SectionComponents'


export const getStaticProps: GetStaticProps = async () => {

  // page_id in DB
  const pageIdDB: number = 26;

  // query DB for page title data
  const pageTitle: pageTitle = await getPageTitleContentFromDB(pageIdDB);

  // Array of pageContent - query DB for pageContent data
  const pageContent: pageContent[] = await getPageContentFromDB(pageIdDB);

  return {
    props: {
      pageTitle,
      pageContent
    }
  }
}

// Home Page takes a pageTitle, and pageContent array
export default function Page({ pageTitle, pageContent }: {
  pageTitle: pageTitle,
  pageContent: pageContent[],
}) {

  return (
    <>
      <ImageBanner title={pageTitle} />

      {/* Section 0 */}
      <Section colour='brown'>
        <Container>
          <Heading h1={true} content={{ title: pageContent[0].title }} />
          <Text content={pageContent[0].text} />
        </Container>
      </Section>

      {/* Section 1 */}
      <Section colour='cream'>
        <ImageGallery imagesArray={pageContent[1].carouselImages!} />
      </Section>
    </>
  )
}

//Meta Data
Page.title = "Gallery";
Page.description = "The beauty of nature and the convenience of modern luxury rolled into one. Explore our gallery to discover what awaits you for your next visit to The Crocodile Hunter Lodge!";